


























































import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import RepositoryFactory from '@/repository/RepositoryFactory';

import * as StringUtil from '@/common/StringUtil';

import SettlementHistory from '@/models/entry/SettlementHistory';
import GoodsOption from '@/models/cart/GoodsOption';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class History extends BaseView {
  private isIndicatorDisplay = false;

  private examTitle = '';

  private settlementHistoryList: SettlementHistory[] = [];

  private ExamRepository = RepositoryFactory.get().exam;

  private EntryRepository = RepositoryFactory.get().entry;

  private async mounted() {
    this.isIndicatorDisplay = true;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const HistoryCss = document.createElement('link');
    HistoryCss.rel = 'stylesheet';
    HistoryCss.href = '/account/css/history.css';
    this.$el.appendChild(HistoryCss);

    const GoodsListCss = document.createElement('link');
    GoodsListCss.rel = 'stylesheet';
    GoodsListCss.href = '/css/goods/css/goods_list.css';
    this.$el.appendChild(GoodsListCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    try {
      await this.getExamInfo();
      await this.getHistory();
    } catch (e) {
      this.$router.replace(this.paths.LOGIN);
    } finally {
      this.isIndicatorDisplay = false;
    }

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 検定情報の取得
   */
  async getExamInfo() {
    // 検定情報APIを呼び出し、検定タイトルを取得
    this.ExamRepository.getExam().then((response) => {
      if (response.status === 200) {
        this.examTitle = response.data.exam_title;
      }
    });
  }

  /**
   * 購入履歴の取得
   */
  async getHistory() {
    // 購入履歴の取得
    await this.EntryRepository.getSettlementHistory().then((response) => {
      if (response.status !== 200 || response.data.histories === undefined) {
        return;
      }
      response.data.histories.forEach((history: any) => {
        const historyObj = new SettlementHistory();
        historyObj.entryCode = history.examination_entry_code;
        // 遷移時にBase64エンコードの文字列を求められるのでエンコード
        historyObj.rankCode = StringUtil.encodeToBase64Url(history.exam_rank_code);
        historyObj.historyDate = StringUtil.toJapanDateString(history.history_datetime, 'YYYY/MM/DD');
        historyObj.totalAmount = Number(history.total_amount);
        historyObj.title = history.title;
        historyObj.status = history.status;
        historyObj.resultCode = history.examination_result_code || '';
        historyObj.isGoods = history.goods_flg === 1;
        historyObj.thumbnail = history.rank_icon_resource_uri || '';
        historyObj.alternativeText = history.rank_icon_alternative_text || '';
        historyObj.quantity = Number(history.quantity);
        if (history.goods_options !== undefined && Array.isArray(history.goods_options)) {
          history.goods_options.forEach((v: any) => {
            const goodsOption = new GoodsOption();
            goodsOption.goodsOptionId = Number(v.goods_option_id);
            goodsOption.goodsOptionTypeTitle = v.goods_option_type_title;
            goodsOption.optionTitle = v.option_title;
            historyObj.goodsOptions.push(goodsOption);
          });
        }

        this.settlementHistoryList.push(historyObj);
      });
    });
  }

  /**
   * 購入履歴の詳細へ。
   * 未受験は受験へ。結果があれば受験結果へ。物販は詳細へ。
   * @param item 購入履歴アイテム
   */
  private transitionSettlementHistoryDetail(item: SettlementHistory) {
    if (item.isGoods) {
      this.$router.replace(`${this.paths.GOODS_DETAIL}?goods_code=${item.rankCode}`);
    } else if (item.resultCode) {
      this.$router.replace(`${this.paths.EXAM_RESULT}?entry=${item.entryCode}&result=${item.resultCode}`);
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.$router.replace({ path: this.paths.EXAM_READY, query: { rank: item.rankCode, examination_entry_code: item.entryCode, is_callback: '0' } });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  formatPrice(amount: number): string {
    return StringUtil.separateNumber(amount);
  }
}
